import React, { useState } from 'react';
import { PageHeader } from '../components/dashboard/PageHeader';
import { Card, CardContent, CardHeader, CardTitle } from '../components/Card';
import { Fingerprint, Shield, Eye, AlertCircle } from 'lucide-react';
import { toast } from 'sonner';
import { Map as MapIcon, ShieldAlert, Eye as EyeIcon, ExternalLink } from 'lucide-react';
import { RelatedWorkflow } from '../components/dashboard/RelatedWorkflow';
const channels = [{
  name: 'X (@presidenri)',
  active: true,
  mentions: 14523
}, {
  name: 'Instagram (@presidenri)',
  active: true,
  mentions: 8240
}, {
  name: 'Facebook Official',
  active: true,
  mentions: 4120
}, {
  name: 'TikTok (Mention)',
  active: true,
  mentions: 22440
}, {
  name: 'YouTube (Channel/Komentar)',
  active: true,
  mentions: 3210
}, {
  name: 'Threads',
  active: false,
  mentions: 0
}, {
  name: 'Telegram Publik',
  active: true,
  mentions: 1240
}];
const feed = [{
  time: '15:42 WIB',
  platform: 'TikTok',
  content: 'Video edit deepfake suara Presiden dengan narasi pembatalan bansos',
  risk: 'KRITIS'
}, {
  time: '15:38 WIB',
  platform: 'X',
  content: 'Cuitan negatif tentang kunjungan Papua dengan tagar provokatif',
  risk: 'TINGGI'
}, {
  time: '15:31 WIB',
  platform: 'FB',
  content: 'Postingan apresiasi MBG di Surabaya viral 12K share',
  risk: 'POSITIF'
}, {
  time: '15:28 WIB',
  platform: 'X',
  content: 'Akun impersonation @presidenri_official terdeteksi',
  risk: 'TINGGI'
}, {
  time: '15:22 WIB',
  platform: 'TikTok',
  content: 'Live streaming pidato terpotong dengan caption menyesatkan',
  risk: 'SEDANG'
}, {
  time: '15:18 WIB',
  platform: 'IG',
  content: 'Story Reels positif kunjungan ke pasar tradisional',
  risk: 'POSITIF'
}, {
  time: '15:11 WIB',
  platform: 'YouTube',
  content: 'Podcast politik membahas isu IKN dengan tone kritis',
  risk: 'SEDANG'
}];
export function DigitalEscort() {
  const [active, setActive] = useState(true);
  const [chans, setChans] = useState(channels);
  return <div className="mx-auto flex w-full max-w-[1600px] flex-col gap-6" data-id="element-1752">
      <PageHeader group="Ancaman & Proteksi" title="Digital Escort Mode" description="Pengawalan digital Presiden 24/7. Setiap sebutan dipantau lintas platform secara real-time." icon={Fingerprint} extraActions={<button onClick={() => {
      setActive(!active);
      toast.success(`Digital Escort ${!active ? 'AKTIF' : 'NONAKTIF'}`);
    }} className={`px-3 py-1.5 rounded font-mono text-[10px] uppercase border ${active ? 'bg-emerald-500/10 text-emerald-500 border-emerald-500/30' : 'bg-muted/30 text-muted-foreground border-border/50'}`} data-id="element-1754">
            <span className={`inline-block size-1.5 rounded-full mr-1.5 ${active ? 'bg-emerald-500 animate-pulse' : 'bg-muted-foreground'}`} data-id="element-1755" />
            {active ? 'AKTIF' : 'NONAKTIF'}
          </button>} data-id="element-1753" />

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-1756">
        {[{
        label: 'Mentions 24J',
        value: '53.7K',
        color: 'text-blue-500',
        icon: Eye
      }, {
        label: 'Sinyal Risiko',
        value: '47',
        color: 'text-amber-500',
        icon: AlertCircle
      }, {
        label: 'Impersonation',
        value: '12',
        color: 'text-red-500',
        icon: Shield
      }, {
        label: 'Channel Aktif',
        value: '6/7',
        color: 'text-emerald-500',
        icon: Fingerprint
      }].map(k => <Card key={k.label} className="bg-card border-border/50" data-id="element-1757">
            <CardContent className="p-4" data-id="element-1758">
              <div data-id="element-1759">
                <p className="font-mono text-[10px] uppercase text-muted-foreground" data-id="element-1760">
                  {k.label}
                </p>
                <p className={`font-heading text-2xl font-bold mt-1 ${k.color}`} data-id="element-1761">
                  {k.value}
                </p>
              </div>
              <k.icon className={`size-6 ${k.color}`} data-id="element-1762" />
            </CardContent>
          </Card>)}
      </div>

      <div className="grid grid-cols-12 gap-4" data-id="element-1763">
        {/* Agenda */}
        <Card className="col-span-12 lg:col-span-4 bg-card border-border/50" data-id="element-1764">
          <CardContent className="p-0" data-id="element-1765">
            {chans.map((c, idx) => <label key={c.name} className="flex items-center justify-between p-2 rounded border border-border/50 bg-muted/20 hover:bg-muted/30 cursor-pointer" data-id="element-1766">
                <div className="flex items-center gap-2" data-id="element-1767">
                  <input type="checkbox" checked={c.active} onChange={() => {
                const next = [...chans];
                next[idx].active = !next[idx].active;
                setChans(next);
                toast.info(`${c.name}: ${next[idx].active ? 'aktif' : 'nonaktif'}`);
              }} className="size-3.5" data-id="element-1768" />
                  <span className="text-xs" data-id="element-1769">{c.name}</span>
                </div>
                <span className="font-mono text-[9px] text-muted-foreground" data-id="element-1770">
                  {c.mentions.toLocaleString('id-ID')}
                </span>
              </label>)}
          </CardContent>
        </Card>

        {/* Live Monitoring */}
        <Card className="col-span-12 lg:col-span-8 bg-card border-border/50" data-id="element-1771">
          <CardContent className="p-4" data-id="element-1772">
            <div className="space-y-2 max-h-[500px] overflow-y-auto" data-id="element-1773">
              {feed.map((f, i) => <div key={i} className={`p-3 rounded border flex items-start gap-3 ${f.risk === 'KRITIS' ? 'border-red-500/30 bg-red-500/5' : f.risk === 'TINGGI' ? 'border-amber-500/30 bg-amber-500/5' : f.risk === 'POSITIF' ? 'border-emerald-500/30 bg-emerald-500/5' : 'border-border/50 bg-muted/20'}`} data-id="element-1774">
                  <div className="flex flex-col items-center gap-1 shrink-0 w-16" data-id="element-1775">
                    <span className="font-mono text-[10px] text-muted-foreground" data-id="element-1776">
                      {f.time}
                    </span>
                    <span className="font-mono text-[9px] bg-muted px-1.5 py-0.5 rounded" data-id="element-1777">
                      {f.platform}
                    </span>
                  </div>
                  <div className="flex-1" data-id="element-1778">
                    <p className="text-xs" data-id="element-1779">{f.content}</p>
                    <span className={`font-mono text-[9px] mt-1 inline-block ${f.risk === 'KRITIS' ? 'text-red-500' : f.risk === 'TINGGI' ? 'text-amber-500' : f.risk === 'POSITIF' ? 'text-emerald-500' : 'text-blue-500'}`} data-id="element-1780">
                      {f.risk}
                    </span>
                  </div>
                </div>)}
            </div>
          </CardContent>
        </Card>
      </div>

      <RelatedWorkflow currentStep="Digital Escort Aktif" nextSteps={[{
      to: '/visit-intel',
      icon: MapIcon,
      label: 'Cek Visit Intel',
      desc: 'Lihat jadwal & risiko kunjungan terkait VVIP.'
    }, {
      to: '/threat-intel',
      icon: ShieldAlert,
      label: 'Threat Intel Aktif',
      desc: 'Pantau ancaman siber paralel saat eskort.'
    }, {
      to: '/deepfake',
      icon: EyeIcon,
      label: 'Verifikasi Deepfake',
      desc: 'Validasi keaslian konten terkait VVIP.'
    }, {
      to: '/platform-reporting',
      icon: ExternalLink,
      label: 'Lapor ke Platform',
      desc: 'Takedown impersonation/threat content.',
      badge: 'EKSTERNAL'
    }]} data-id="element-1781" />
    </div>;
}